import { useEffect, useReducer } from 'react';
import { DateTime } from 'luxon';

import { Text } from '@equip.health/ui';

import {
  formatMessageFullTimestamp,
  formatMessageTimestamp,
} from './maiChat.util';

const REFRESH_INTERVAL_MS = 60_000;

interface MaiChatTimestampProps {
  createdAt: string;
}

const MaiChatTimestamp = ({ createdAt }: MaiChatTimestampProps) => {
  // Each re-render recomputes the label against the current time.
  const [, refresh] = useReducer((tick: number) => tick + 1, 0);
  // Today's labels age ("Just now" → "2:14 PM" → "May 5" at midnight); older
  // ones are fixed.
  const isFromToday = DateTime.fromISO(createdAt).hasSame(
    DateTime.now(),
    'day',
  );

  useEffect(() => {
    if (!isFromToday) return undefined;
    const intervalId = setInterval(refresh, REFRESH_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [isFromToday, refresh]);

  const label = formatMessageTimestamp(createdAt);
  if (!label) return null;
  return (
    <Text
      data-testid="mai-chat-message__timestamp"
      color="neutral.tertiary"
      title={formatMessageFullTimestamp(createdAt)}
      variant="caption"
    >
      {label}
    </Text>
  );
};

export default MaiChatTimestamp;
